import Vue from 'vue'
import Router from 'vue-router'

const index = () => import('@/pages/index');
const view404 = () => import('@/pages/view404');
const kamoCase = () => import('@/pages/kamoCase');
const kamoCaseDetails = () => import('@/pages/kamoCaseDetails');
const industryNews = () => import('@/pages/industryNews');
const industryNewsDetails = () => import('@/pages/industryNewsDetails');
const store = () => import('@/pages/Solution/store');
const restaurant = () => import('@/pages/Solution/restaurant');
const hotel = () => import('@/pages/Solution/hotel');
const takeOutFood = () => import('@/pages/Solution/takeOutFood');
const productGuide = () => import('@/pages/productGuide');
const IntelligentIndex = () => import('@/pages/IntelligentHardware/IntelligentHardware');
const nailMachine = () => import('@/pages/IntelligentHardware/nailMachine');
const flowerPulling = () => import('@/pages/IntelligentHardware/flowerPulling');
const pos50 = () => import('@/pages/IntelligentHardware/pos50');
const pos70 = () => import('@/pages/IntelligentHardware/pos70');
const pos100 = () => import('@/pages/IntelligentHardware/pos100');
const pos130 = () => import('@/pages/IntelligentHardware/pos130');
const AM43 = () => import('@/pages/IntelligentHardware/AM43');
const KMP58 = () => import('@/pages/IntelligentHardware/KMP58');
const KMP360 = () => import('@/pages/IntelligentHardware/KMP360');
const CLP180 = () => import('@/pages/IntelligentHardware/CLP180');
const kamoIntroduction = () => import('@/pages/kamoIntroduction');
const agentJoining = () => import('@/pages/agentJoining');

Vue.use(Router)

const makeRoute = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      redirect: '/index'
    },
    {
      path: '/index',
      name: 'index',
      component: index,
      meta: {
        title: '卡莫-新零售粉丝裂变营销系统_微信分销_微商城_微信小程序开发'
      }
    },
    {
      path: '/case',
      name: 'case',
      component: kamoCase,
      meta: {
        title: '卡莫案例'
      }
    },
    {
      path: '/Solution/store',
      name: 'store',
      component: store,
      meta: {
        title: '门店行业解决方案-卡莫解决方案_卡莫小程序分销系统服务_卡莫',
        content: '卡莫裂变营销门店管理系统，让门店管理变得更简单。门店仅需购买一台打印机，即可轻松实现开单、收款、开票、营销等需求。并赠送微商城及多种营销工具，帮助门店实现线上线下一体化经营。',
        keywords: '卡莫解决方案，卡莫门店解决方案，卡莫门店经营解决方案，门店系统，连锁门店管理系统'
      }
    },
    {
      path: '/Solution/restaurant',
      name: 'restaurant',
      component: restaurant,
      meta: {
        title: '卡莫餐饮行业解决方案-卡莫解决方案_卡莫餐饮系统',
        content: '卡莫裂变营销餐饮管理系统专为餐饮行业商户提供软硬件一体化的点餐收银及营销系统，整合发票开具业务，简化开票流程，为商户节省经营成本，提高服务效率。',
        keywords: '卡莫餐饮解决方案，卡莫餐饮系统，卡莫解决方案，智能餐饮解决方案'
      }
    },
    {
      path: '/Solution/hotel',
      name: 'hotel',
      component: hotel,
      meta: {
        title: '卡莫酒店行业解决方案-卡莫解决方案_卡莫酒店系统',
        content: '卡莫裂变营销酒店管理系统一站式解决了酒店在微官网、微商城、在线订房、裂变分享营销、在线客房服务、多业态管理及多种方式开票等方面的需求。致力于提高酒店的工作效率，规范酒店的业务流程，帮助酒店管理者及时、全面地了解经营信息，做出更加准确的决策，从而有效地提高酒店的经营效益。',
        keywords: '卡莫酒店解决方案，卡莫方案，客房服务方案，酒店订单系统，酒店营销系统'
      }
    },
    {
      path: '/Solution/takeOutFood',
      name: 'takeOutFood',
      component: takeOutFood,
      meta: {
        title: '卡莫外卖行业解决方案-卡莫解决方案_卡莫外卖系统',
        content: '卡莫裂变营销外卖管理系统 只需一台打印机即可自动同时接美团、饿了么等外卖平台的订单，更有多重经营报表可以在手机上轻松查看，致力于为商户提供最方便快捷的外卖运营模式。',
        keywords: '卡莫外卖系统，卡莫外卖解决方案，外卖saas软件，外卖小程序'
      }
    },
    {
      path: '/guide',
      name: 'productGuide',
      component: productGuide
    },
    {
      path: '/hardware/index',
      name: 'IntelligentIndex',
      component: IntelligentIndex
    },
    {
      path: '/hardware/nailMachine',
      name: 'nailMachine',
      component: nailMachine
    },
    {
      path: '/hardware/flowerPulling',
      name: 'flowerPulling',
      component: flowerPulling
    },
    {
      path: '/hardware/pos50',
      name: 'pos50',
      component: pos50
    },
    {
      path: '/hardware/pos70',
      name: 'pos70',
      component: pos70
    },
    {
      path: '/hardware/pos100',
      name: 'pos100',
      component: pos100
    },
    {
      path: '/hardware/pos130',
      name: 'pos130',
      component: pos130
    },
    {
      path: '/hardware/AM43',
      name: 'AM43',
      component: AM43
    },
    {
      path: '/hardware/KMP58',
      name: 'KMP58',
      component: KMP58
    },
    {
      path: '/hardware/KMP360',
      name: 'KMP360',
      component: KMP360
    },
    {
      // IntelligentHardware
      path: '/hardware/CLP180',
      name: 'CLP180',
      component: CLP180
    },
    {
      path: '/about',
      name: 'kamoIntroduction',
      component: kamoIntroduction
    },
    {
      path: '/caseDetails/:detailId',
      name: 'caseDetails',
      component: kamoCaseDetails
    },
    {
      path: '/news',
      name: 'industryNews',
      component: industryNews,
      meta: {
        title: '行业新闻'
      }
    },
    {
      path: '/newsDetails/:detailId',
      name: 'newsDetails',
      component: industryNewsDetails 
    },
    // {
    //   path:"/detail/:detailId",
    //   name:"Detail",
    //   component:Detail
    // },
    {
      path: '/agent',
      name: 'agent',
      component: agentJoining,
      meta:{
        title: '卡莫外卖系统，卡莫外卖解决方案，外卖saas软件，外卖小程序',
        content: '如何成为卡莫代理商，只需一步在线申请，代理商的优势拥有海量资源、丰厚返利，给予市场、培训和驻地支持，在新零售、全场景、SaaS三大风口，携手卡莫共掘万亿市场。',
        keywords: '卡莫代理，卡莫招商，卡莫代理商申请，代理商合作，小程序代理，微信商城代理，saas系统代理'
      }
    },
    //数组最后
    {
      path: '*',
      name: 'view404',
      component: view404
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

makeRoute.beforeEach((to, from, next) => {
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.name = 'description'
    meta.content = to.meta.content;
    head[0].appendChild(meta)
   }
   if (to.meta.keywords) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.name = 'keywords'
    meta.content = to.meta.keywords;
    head[0].appendChild(meta)
   }
   /* 路由发生变化修改页面title */
   if (to.meta.title) {
    sessionStorage.setItem('title', to.meta.title)
   }
   if (to.params.title) {
    sessionStorage.setItem('title',to.params.title)
   }
   if (to.params.content) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.name = 'description'
    meta.content = to.params.content;
    head[0].appendChild(meta)
   }
   if (to.params.keywords) {
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    meta.name = 'keywords'
    meta.content = to.params.keywords;
    head[0].appendChild(meta)
   }
   document.title = sessionStorage.getItem('title')
   next()
})

export default makeRoute


// WEBPACK FOOTER //
// ./src/router/index.js